<h2 mat-dialog-title *ngIf="peo.peoId" class="bg-blue text-white">PEO Information Modification</h2>
<h2 mat-dialog-title *ngIf="!peo.peoId" class="bg-blue text-white">New PEO Information</h2>
<mat-dialog-content>
  <p *ngIf="peo.peoId">Use the form below to fill out the information for the {{ peo.peoId }} PEO.</p>
  <p *ngIf="!peo.peoId">Use the form below to fill out the information for the new PEO.</p>
  <form [formGroup]="form" class="app-form">
    <fieldset>

      <!-- PEO ID -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>PEO ID</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.peoId" [readonly]="!!peo.peoId"
               placeholder="123*CORP"
               type="text">
        <mat-error *ngIf="form.controls.peoId?.hasError('required')">A unique PrismHR identifier for the PEO is
          required.
        </mat-error>
        <mat-hint>This should be exactly what appears in PrismHR. If an asterisk &lpar;<code>&ast;</code>&rpar; is in
          the ID in PrismHR, it must be included here as well.
        </mat-hint>
      </mat-form-field>

      <!-- PEO Name -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>Name</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.name" type="text">
        <mat-error *ngIf="form.controls.name?.hasError('required')">
          A name for the PEO is required.
        </mat-error>
      </mat-form-field>
    </fieldset>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" color="icon-slate">
    <mat-icon>cancel</mat-icon>
    Cancel
  </button>

  <button mat-button (click)="save()" [disabled]="form.invalid || formDisabled"
          matTooltip="Commit the PEO to persistent storage." color="icon-green">
    <mat-icon>save</mat-icon>
    Save
  </button>
</mat-dialog-actions>
